import { getStateFull, doAction, dispatch } from '../../core/redux/store';
import { AT } from '../../actions/actionTypes';
import * as MyKeysApiOrders from '../../core/apis/mykeys/orders';

import { getColumns } from '../../components/ordersPage/columns';
import * as DT from '../datatable';
import * as Devices from '../devices';
import * as DTHelper from '../datatable/utils';

import {
  State,
  SearchPageFetchPL,
  SearchPageSuccessPL,
  SearchPageRes,
  Order,
  FilterCriteria,
  SearchPageErrorPL,
} from './model';
import { ErrorDataResponse } from '../../core/apis/mykeys/exceptions';
import { SortCriteria } from '../datatable';
import {
  buildCriteraList,
  updateCriteria,
  clearCriterionByType,
} from '../../core/apis/mykeys/searchCriteria';
import { getTotalsFromSelectedKeys, msgSearchError } from './utils';
import { criterionNames, SearchCriteriaDto } from '../../interfaces';
import { FeedbackAddPL } from '../../models';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

export const getState = (): State => getStateFull().ordersState;

export const changeTablePage = (pageNumber: number) =>
  dispatch(DT.changeTablePage(AT.ORDERS.TABLE_PAGE_CHANGE, pageNumber));

export const changeTableSizePage = (pageSize: number) =>
  dispatch(DT.changeTableSizePage(AT.ORDERS.TABLE_PAGESIZE_CHANGE, pageSize));

export const changeTableSorting = (sort: SortCriteria[]) =>
  dispatch(DT.changeTableSorting(AT.ORDERS.SORT_CRITERIA_UPADATED, sort));

export const updateTableItemSelection = (item: Order) =>
  dispatch(DT.updateTableItemSelection(AT.ORDERS.TABLE_TOGGLE_ITEM, item));

export const updateTableSelectAll = () => {
  dispatch({ type: AT.ORDERS.TABLE_TOGGLE_ALL });
};

export const isTableItemSelected: DT.IsItemSelectedType<Order> = (o) =>
  DTHelper.isTableItemSelected(o, getState().selection);

export const clearSelection = () =>
  dispatch({ type: AT.ORDERS.CLEAR_SELECTION });

export const updateFilterCriteria = (
  criteria: FilterCriteria,
  isLoading: boolean
) => {
  if (isLoading) return;
  doAction<FilterCriteria>(AT.ORDERS.FILTER_CRITERIA_UPADATED, criteria);
};

export const updateDTColumns = (columns: DT.TableColumn[]) => {
  doAction<DT.TableColumn[]>(AT.ORDERS.TABLE_COLUMNS, columns);
};

export const updateColumns = () => updateDTColumns(getColumns());

/* Server Actions */

export const searchPage = (pageNumber: number) => {
  const orderState = getState();
  const page = DTHelper.getDataPage(orderState.data.pages, pageNumber);

  if (page && page.isFetching) return;

  const basePayload: DT.SearchPageBasePayload = {
    pageNumber,
    version: orderState.data.version,
  };

  MyKeysApiOrders.searchPage(pageNumber, orderState)
    .then((res: SearchPageRes) => {
      const payload = { ...res, ...basePayload };
      doAction<SearchPageSuccessPL>(AT.ORDERS.SEARCH_SUCCESS, payload);
    })
    .catch((err: ErrorDataResponse) => {
      Logger.warn([err], LogArea.Redux);
      doAction<SearchPageErrorPL>(AT.ORDERS.SEARCH_ERROR, basePayload);
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, {
        content: [msgSearchError],
      });
    });

  doAction<SearchPageFetchPL>(AT.ORDERS.SEARCH_FETCH, basePayload);
};

export const getCriteria = (keys: string[]) => {
  const ordersState = getState();
  const criteria = buildCriteraList(ordersState.filters, ordersState.sort);
  // remove manual filters on search
  criteria.criteriaDtos = clearCriterionByType(
    criteria.criteriaDtos,
    SearchCriteriaDto.orderNumber
  );
  // add selected items
  keys.map((k) =>
    updateCriteria(criteria.criteriaDtos, criterionNames.orderNumber, k)
  );
  return criteria;
};

export const getTotals = (keys: string[] = []) => {
  const ordersState = getState();
  const { data } = ordersState;

  return getTotalsFromSelectedKeys(keys, data) as Devices.TotalsByType;
};
